<template>
  <div v-if="bannerList.length > 0">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>
    <div style="position: relative">
      <div class="homeHeder">
        <img class="leftImg" @click="changleftshow" src="/static/image/home_muen.png" alt="" />
        <div class="rbox" @click="$parent.openKefu">
          <img src="/static/image/home_service.png" alt="" />
          客服
        </div>
      </div>
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.src" style="width: 100%" alt="" />
        </van-swipe-item>
        <template #indicator>
          <div class="swiper-dots">
            <div class="num">{{ current + 1 }}</div>
            <div class="sign">/</div>
            <div class="num">4</div>
          </div>
        </template>
      </van-swipe>
    </div>

    <!-- 公告 -->
    <div style="background-color: #ede9e7; padding: 6px 0 0" v-if="homenoticelis.length > 0">
      <div class="gonggao">
        <img style="width: 20px" src="/static/image/home_notice.66939586521463adbe87e2a72aa8ecad.png" alt="" />
        <div style="flex: 1">
          <van-notice-bar color="#cf866b" background="#ede9e7" scrollable
            ><span v-for="(item, index) in homenoticelis" @click="openGogao(item)" :key="index">{{ item }}</span></van-notice-bar
          >
        </div>
        <img @click="$parent.goNav('/message')" style="width: 68px" src="/static/image/home_hotsports.718f002d63ddbf2c3902907f2226a28b.png" alt="" />
      </div>
    </div>
    <!-- 公告 -->
    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />

        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}

          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
        </div>
      </div>
    </div>
    <!-- 用户信息栏 -->
    <div class="xiding">
      <div class="caosuo">
        <div class="lefsg" v-if="$store.state.token">
          <div class="name">{{ $store.state.userInfo.username }}</div>
          <div class="mey">
            <span>￥</span>{{ $store.state.userInfo.balance }}
            <img 
              src="/static/image/shuaxin.png" 
              alt="刷新" 
              class="refresh-btn" 
              @click="refreshBalance"
            />
          </div>
        </div>
        <div v-else class="lefsg" @click="$parent.goNav('/login')">
          <div class="name">未登录</div>
          <div class="mey">登录后查看</div>
        </div>
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <img src="/static/style/feature_moneydraw.cbeb513bc9fd00ecc5372fc0e54a84c0.png" alt="" />
            存款
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/feature_moneysave.4b60fbaf4ee368d1e7060133f62690c9.png" alt="" />
            取款
          </div>
          <div class="lisImg" @click="$parent.goNav('/vip')">
            <img src="/static/style/feature_vip.16d90880db727a342209f4439a9b3a12.png" alt="" />
            VIP
          </div>
        </div>
      </div>
    </div>
    <!-- 游戏栏 -->
    <div class="gameBoxs">
      <!-- 左侧边栏: 显示游戏分类 (来自 /api/getGameType) -->
      <div class="lfst">
        <div v-if="!loadingLeftSide && (!leftSideItems || leftSideItems.length === 0)" class="loading-placeholder">暂无分类</div>
        <!-- 添加热门选项，固定在第一位 -->
        <div 
          :class="[gameType === 'hot' ? 'ls active' : 'ls']" 
          @click="changGameType('hot')"
        >
          <img :src="gameType === 'hot' ? '/static/image/hot1.png' : '/static/image/hot2.png'" alt="热门" /> 
          <span>热门</span>
        </div>
        <!-- Loop through game categories fetched for the left side -->
        <div v-for="item in leftSideItems"
             :key="item.id"
             :class="[gameType == item.id ? 'ls active' : 'ls']" 
             @click="changGameType(item.id)">
          <!-- Use 'pic' and 'pic_active' fields with getImageUrl -->
          <img :src="getImageUrl(gameType == item.id ? item.pic_active : item.pic)" :alt="item.name" /> 
          <span>{{ item.name }}</span>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="rigts game-list-container">

          <!-- Hot Games Wrapper -->
          <div v-if="!loadingHotGames && gameType === 'hot' && hotGames.length > 0" class="hot-games-wrapper">
            <!-- 热门游戏区域 - 简化 -->
            <div class="gemini-hot-games-area-simplified">
              <div v-for="game in hotGames"
               :key="game.id"
                   class="gemini-hot-item-simplified"
                   @click="handleGameClick(game)">
                <div class="gemini-hot-item-content-simplified">
                  <!-- 游戏图片容器 -->
                  <div class="gemini-hot-image-wrapper-simplified">
                    <img class="gemini-hot-image-simplified" :src="game.mobile_img" :alt="game.name">
                    <!-- 新游戏标记 (保留，如果需要可以再移除) -->
                    <img v-if="game.is_new === 1"
                         src="/static/image/new-tag.png"
                         alt="新"
                         class="gemini-tag-simplified gemini-tag-new-simplified">
                  </div>
                  <!-- 游戏名称 -->
                  <div class="gemini-hot-name-simplified">{{ game.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Other Games Wrapper -->
          <div v-else-if="!loadingAllGames && gameType !== 'hot' && filteredGames.length > 0" class="other-games-wrapper">
            <!-- 其他游戏类别列表布局 -->
            <div v-for="game in filteredGames"
                 :key="game.id"
                 class="game-card"
                 @click="handleGameClick(game)">
                <!-- Game info content -->
                <div class="game-card-content">
                  <div class="game-title">{{ game.name }}</div>
                </div>
                <!-- Image on the right -->
                <img class="game-card-image"
                    :src="getImageUrl(game.image)" 
                    :alt="game.name" />
          </div>
          </div>

           <!-- Empty Placeholder Wrapper -->
          <div v-if="!loadingAllGames && !loadingHotGames &&
                       ((gameType === 'hot' && hotGames.length === 0) ||
                        (gameType !== 'hot' && filteredGames.length === 0))"
               class="loading-placeholder-wrapper">
             <div class="loading-placeholder">该分类下暂无游戏</div>
          </div>
      </div>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiFun from "@/http/api.js";

export default {
  name: 'index',
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: true,
      goInfo: null,
      
      // New state for left sidebar
      leftSideItems: [],
      loadingLeftSide: false,
      
      // New state for right side games
      allGames: [], 
      loadingAllGames: false,
      
      // 热门游戏专用数据
      hotGames: [],
      loadingHotGames: false,
    };
  },
  computed: {
    // Filters the games based on the category selected on the left
    filteredGames() {
       console.log(`Filtering games. Current gameType (category ID): ${this.gameType}`);
       if ((!this.gameType && this.gameType !== 'hot') || !this.allGames || this.allGames.length === 0) {
         console.log('No gameType selected or allGames is empty. Returning empty array.');
         return [];
       }
       
       // 热门游戏由单独的接口获取，不再在这里筛选
       if (this.gameType === 'hot') {
         return this.hotGames;
       }
       
       console.log(`Filtering ${this.allGames.length} total games.`);
       
       // Filter allGames where the game's type matches the selected gameType (category ID)
       const result = this.allGames.filter(game => {
         return game.type === this.gameType;
       });
       
       console.log(`Filtering result count: ${result.length}`);
       return result;
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    
    // 默认选择热门游戏
    this.gameType = 'hot';
    
    that.fetchLeftSideItems(); // Fetch data for the left sidebar
    that.fetchAllGames();      // Fetch ALL games for right side filtering
    that.fetchHotGames();      // Fetch hot games separately
  },
  methods: {
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(typeId) {
      console.log(`changGameType called with typeId: ${typeId} (Type: ${typeof typeId})`);
      
      // 处理热门游戏的特殊情况
      if (typeId === 'hot') {
        this.gameType = 'hot';
        console.log(`gameType updated to: hot (Type: string)`);
        // 如果热门游戏数据为空，则加载热门游戏
        if (this.hotGames.length === 0 && !this.loadingHotGames) {
          this.fetchHotGames();
        }
        return;
      }
      
      // 正常处理数字类型的游戏类型ID
      const numericTypeId = Number(typeId); 
      if (!isNaN(numericTypeId)) {
          this.gameType = numericTypeId;
          console.log(`gameType updated to: ${this.gameType} (Type: ${typeof this.gameType})`);
      } else {
          console.error("Invalid typeId received:", typeId);
      }
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, '复制成功！');
      document.body.removeChild(cInput);
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
        })
        .catch(res => {
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    async fetchLeftSideItems() {
       try {
         const res = await apiFun.post('/api/getGameType'); 
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.leftSideItems = res.data.filter(item => item.status === 1);
           if (this.leftSideItems.length > 0 && this.gameType === 0) { 
             // Use $nextTick to ensure computed property recalculates after gameType is set
             this.$nextTick(() => { 
                // Ensure we set it as a number
                const initialTypeId = Number(this.leftSideItems[0].id);
                if (!isNaN(initialTypeId)){
                    this.gameType = initialTypeId; 
                    console.log("Initial gameType set to:", this.gameType);
                } else {
                    console.error("Invalid initial typeId:", this.leftSideItems[0].id);
                }
             });
           }
         } else {
           console.error("Failed to fetch left side items:", res);
           this.leftSideItems = [];
         }
       } catch (error) {
         console.error("Error fetching left side items:", error);
         this.leftSideItems = [];
       }
     },
     async fetchAllGames() {
       try {
         const res = await apiFun.post('/api/getGameTypeList', {}); 
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.allGames = res.data.filter(game => game.status === 1);
           console.log(`Fetched ${this.allGames.length} active games for filtering:`, this.allGames.map(g => ({id: g.id, name: g.name, type: g.type}))); 
         } else {
           console.error("Failed to fetch all games from /api/getGameTypeList:", res);
           this.allGames = []; 
         }
       } catch (error) {
         console.error("Error fetching all games from /api/getGameTypeList:", error);
         this.allGames = []; 
       }
     },
     async fetchHotGames() {
       try {
         // 调用接口获取热门游戏数据
         const res = await apiFun.post('/api/game/list', { is_hot: 1 });
         if (res && res.code === 200 && Array.isArray(res.data)) {
           this.hotGames = res.data.filter(game => game.app_state === 1);
           console.log(`获取到${this.hotGames.length}个热门游戏`);
         } else {
           console.error("获取热门游戏失败:", res);
           this.hotGames = [];
         }
       } catch (error) {
         console.error("获取热门游戏异常:", error);
         this.hotGames = [];
       }
     },
     getImageUrl(relativePath) {
        if (!relativePath || typeof relativePath !== 'string') return '';
        if (relativePath.startsWith('http') || relativePath.startsWith('data:')) { return relativePath; }
        if (relativePath.startsWith('/static/')) { return relativePath; }
        return '/storage/' + relativePath.replace(/^\/+/, ''); 
    },
    handleGameClick(game) {
      console.log('点击游戏:', game);

      const requiresListPage = game.single === 2 || game.single === '2';

      if (requiresListPage) {
        console.log('游戏需要跳转到列表页');
        let pathId, platformParam, gameTypeListIdParam, gameCodeParam;

        if (this.gameType === 'hot') {
          // --- 热门游戏处理 (跳转列表) ---
          pathId = game.game_type_id || '13';
          platformParam = game.platform_name || 'pg';
          gameTypeListIdParam = game.game_type_id || '13';
          gameCodeParam = game.game_code || 'null';
        } else {
          // --- 普通游戏分类处理 (跳转列表) ---
          pathId = game.id || '13'; // game.id is game_type_list.id here
          platformParam = game.platform || 'pg';
          gameTypeListIdParam = game.id || '13'; // game.id is game_type_list.id here
          gameCodeParam = 'null';
        }
        this.$parent.goNav(`/gameTypeList/${pathId}?platform=${platformParam}&game_type_list_id=${gameTypeListIdParam}&game_code=${gameCodeParam}`);

      } else {
        // --- 直接打开游戏 (single !== 2) ---
        console.log('直接打开游戏');
        let gameIdToOpen;
        let gameCodeToOpen = ''; // 默认为空字符串

        if (this.gameType === 'hot') {
          // 对于热门游戏，继续使用 game_type_id 和 game_code
          gameIdToOpen = game.game_type_id;
          gameCodeToOpen = game.game_code || '';
          console.log(`[热门] 调用 openGamePage: ID=${gameIdToOpen}, Code=${gameCodeToOpen}`);
        } else {
          // 对于非热门游戏 (来自 /api/getGameTypeList) 且 single !== 2:
          // 使用 game.id (即 game_type_list.id) 作为 ID
          // 传递空字符串作为 game_code
          gameIdToOpen = game.id; // 使用列表项 ID
          gameCodeToOpen = '';   // game_code 设为空
          console.log(`[非热门/直接打开] 调用 openGamePage: ListItemID=${gameIdToOpen} (来自 game.id), Code=${gameCodeToOpen}`);
        }

        // 确保 gameIdToOpen 有效再调用
        if (typeof gameIdToOpen !== 'undefined' && gameIdToOpen !== null) {
             this.$parent.openGamePage(game.name, gameIdToOpen, gameCodeToOpen);
        } else {
             console.error("无法确定有效的 gameIdToOpen 来调用 openGamePage", game);
             this.$parent.showTost(0, '打开游戏失败，参数错误'); // 给用户一个提示
        }
      }
    },
    async refreshBalance() {
      try {
        this.$parent.showLoading && this.$parent.showLoading();
        const res = await this.$apiFun.post('/api/balance', {});
        if (res.code === 200) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.$store.commit('changUserInfo');
        } else {
          this.$parent.showTost && this.$parent.showTost(0, res.message || '刷新失败');
        }
      } catch (e) {
        this.$parent.showTost && this.$parent.showTost(0, '网络错误');
      } finally {
        this.$parent.hideLoading && this.$parent.hideLoading();
      }
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
.domainModal_content__1nBgc {
  overflow: auto;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAYAAADDhn8LAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTk4MzlBNjE0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTk4MzlBNjA0NjU1MTFFOUExNjRFQ0I3RTQ0NEExQjMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Q0E3RUNERkE0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Q0E3RUNERkI0NjExMTFFOTg5NzI4MTM2Rjg0OUQwOEUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Gh5BPAAACTUlEQVR42uzcQW7jQAwFUdN306l1uWwNww5kqdsmm6/2MwtVCp8CosQtP9vg/2+/gY+DRAMBgqnjIp2PaCxCLLldpPARRIiFj1yBbMV+cHZh9PURRLQNhY8kgWyL/WDtwujjI8hoE8rKLqb5CDJaRMJHokC6yKgSCR9JAukmokIknCQJpLOIrJFwMsBJELFcKHwM9BFkLBMKFxNcBCHlQ+FhoocgpVwwnv0Xn30QBJGMC0QcaBVJiAMiec/dcwKuL4j1QMsVCXFAJE4s4NQA3K/8Y6DzO4g40P7UcmIBJxbEesCKWBDg8wWxHrAiFgT4fEGsB/CwIhYE+AeBAAdPLOcV8HRmWRDAiQVcO7GcV8CLM8uCAE4sYMyJ5cwCHs4rCwI4sYBxJ5YzC84rCwKcXxArAuthQYDzC2JF0H49LAhwYUGsCFqvx5EF2T07dMaJBetx4cRyaqFtHJ8EIhK0i8OJBQxcECuCVutxJhCRoE0cZwMRyRcFefa/ffZBVPogePihhyCnbBhcfMFFEFM+DD4m+ghSlgmDkwlOgpAl4+BkkJMgZdk4+EgaSCcpVX7bmY9kgXQQU+1TgE0c+QJZUUz1b2T4SBbIKmJW+3iMj2SBVBWz+leVfCQLpIqYbp8b85EskIxyfIOfK5Sf+wiCRJEsllQ+oqEkQfBxmD8BBgA5hVjXyrBNUQAAAABJRU5ErkJggg==);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #ede9e7;
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .mey {
      margin-top: 3px;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
    .mey span {
      font-size: 10px;
      font-weight: 400;
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 56px;
      text-align: center;
      font-size: 12px;
      img {
        width: 60%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.xiding {
  background-color: #ede9e7;
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  z-index: 10;
}

// 游戏
.gameBoxs {
  background: #ede9e7;
  -webkit-box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-shadow: inset 0 0.08rem 0.16rem rgb(227 170 150 / 50%);
  box-sizing: border-box;
  padding: 10px;
  color: #cf866b;
  height: auto;
  margin-bottom: 50px;
  padding-bottom: 60px;
  display: flex;
  justify-content: space-between;
  .lfst {
    width: 36px;
    background: #eff3ff;
    border-radius: 20px;
    border: 1px solid #fff;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-shrink: 0;
    align-self: flex-start;
    .ls.active {
      color: #fff;
      background: #cf866b;
    }
    .ls {
      text-align: center;
      border-radius: 20px;
      padding: 7px 0;
      min-height: 60px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        width: 30px;
        display: block;
        margin: 0 auto;
      }
      span {
        font-size: 10px;
        display: block;
        margin-top: 3px;
      }
    }
  }
  .rigts {
    flex: 1;
    box-sizing: border-box;
  }
}
// app下载
.appbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.8rem;
  box-sizing: border-box;
  padding-right: 15px;
  .colse {
    width: 0.4rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: 1rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.23rem;
      font-weight: 700;
    }
    .cx {
      font-size: 0.2rem;
      color: #ccc;
    }
  }
}
.loading-placeholder {
  text-align: center;
  padding: 20px;
  color: #999;
  width: 100%;
}

/* 热门游戏区域 - 简化 */
.gemini-hot-games-area-simplified {
  display: flex;
  flex-wrap: wrap;
  background: transparent;
  padding: 5px;
  box-sizing: border-box;
}

.gemini-hot-item-simplified {
  width: 33.333%;
  padding: 8px;
  box-sizing: border-box;
}

.gemini-hot-item-content-simplified {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.gemini-hot-image-wrapper-simplified {
  position: relative; /* 用于定位新标签 */
  width: 100%;
  padding-top: 100%; /* 关键：强制容器高度等于宽度，形成正方形 */
  border-radius: 12px; /* 保留圆角 */
  overflow: hidden;
}

.gemini-hot-image-simplified {
  position: absolute; /* 让图片填充绝对定位的容器 */
  top: 0;
  left: 0;
  width: 100%; /* 图片宽度占满容器 */
  height: 100%;     /* 图片高度也占满容器 */
  display: block;
  object-fit: cover; /* 关键：图片覆盖整个容器，保持比例，多余部分裁剪 */
  border-radius: 12px; /* 给图片本身也加上圆角 */
}

.gemini-tag-simplified {
  position: absolute;
  z-index: 2;
}

/* 新游戏标记 */
.gemini-tag-new-simplified {
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
}

.gemini-hot-name-simplified {
  font-size: 13px;
  color: #555;
  margin-top: 6px;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移除其他 gemini- 开头的旧样式 */

/* 热门标记 */
.hot-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  z-index: 2;
}

.hot-tag img {
  width: 100%;
  height: 100%;
}

/* 平台标识 */
.platform-tag {
  position: absolute;
  bottom: 30px;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
}

/* Game Section Layout */
.gameBoxs {
  display: flex;
  // Remove potential old grid styles if any
}

.lfst {
  // Keep existing left sidebar styles
  width: 80px; // Example width, keep original
  flex-shrink: 0;
}

/* Right Side List Container */
.rigts.game-list-container {
  flex-grow: 1;
  padding: 10px 15px;
  overflow-y: auto; 
  overflow-x: hidden;
  box-sizing: border-box;
  max-height: 590px; /* Change max-height limit to 550px */
}

/* New List Item Styles - Targeting the new design */
.game-card {
  background-color: #ffffff; /* White background */
  background-image: url('/static/image/game_card_bg.png'); /* Restore background image */
  background-size: cover; /* Cover the area */
  background-repeat: no-repeat; /* Restore */
  background-position: top left; /* Position from top left */
  border-radius: 19px; /* Rounded corners */
  padding: 0; /* Reset padding */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* Softer shadow */
  position: relative; /* Keep for absolute positioning of image */
  cursor: pointer;
  min-height: 170px; /* Set minimum height to 170px */
  height: 170px; /* Set fixed height to 170px */
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px; /* Add margin for spacing */
}

.game-card-content {
  /* Apply padding only to the content area */
  padding: 10px 10px 10px 15px; /* Keep basic padding */
  padding-right: 140px; /* Increase padding to reserve more space for image */
  /* Add text overflow styles */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Ensure content is vertically centered if needed (might require line-height or other methods now) */
  height: 100%; /* Make content take full height */
  display: flex; /* Re-add flex just for vertical centering inside content */
  align-items: center;
  /* --- Hide the content visually but keep in DOM --- */
  opacity: 0;
  pointer-events: none; /* Prevent interaction */
  position: relative; /* Ensure it layers correctly if needed */
  z-index: 1; /* Place it conceptually above the image, though invisible */
}

.game-title {
  font-size: 15px;
  font-weight: 600;
  color: #444; /* Keep color definition */
}

.game-card-image {
  height: 100%; /* Make image height 100% of the card */
  width: 100%; /* Make image width 100% of the card */
  object-fit: cover; /* Cover the area, maintaining aspect ratio */
  border-radius: 0; 
  position: absolute;
  top: 0;
  left: 0; /* Ensure image starts from the left edge */
}

/* Loading/Empty Placeholder Styles */
.loading-placeholder {
    padding: 20px;
    text-align: center;
    color: #888;
    font-size: 14px;
}

/* Wrapper for Hot Games Area */
.hot-games-wrapper {
  padding: 0 6px; /* Reduced side padding */
}

/* Wrapper for Other Games List */
.other-games-wrapper {
  padding: 0 6px; /* Reduced side padding */
}

/* Wrapper for Loading Placeholder */
.loading-placeholder-wrapper {
  padding: 0 6px; /* Apply padding here, reduced */
  width: 100%; /* Ensure it takes full width */
  box-sizing: border-box;
}

.refresh-btn {
  width: 20px;
  height: 20px;
  margin-left: 8px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue